import PlatformAccessRevoked from '../components/MessagePages/PlatformAccessRevoked';
import PageLayout from '../components/pageLayout';

function PlatformAccessRevokedPage() {
    return (
        <PageLayout children={<PlatformAccessRevoked />} />
    );
}

export default PlatformAccessRevokedPage;
